import { createFileRoute, notFound, useNavigate } from '@tanstack/react-router';
import { useAtom } from 'jotai/index';
import { Toast } from 'primereact/toast';
import * as React from 'react';
import { useHierarchyEndpoint } from '~/api/useHierarchyEndpoint';
import { toastAtom } from '~/atoms/toastAtom';
import { FundForm, FundFormStatusEvt } from '~/components/forms/fund_form';
import { Breadcrumb } from '~/components/ui/layout/navigation/breadcrumb/Breadcrumb';
import { HeaderContainer } from '~/components/ui/layout/page/HeaderContainer';
import { PageTagline } from '~/components/ui/layout/page/PageTagline';
import { canAccess } from '~/utils/rbac';

export const Route = createFileRoute('/_authLayout/documents/fund-create')({
  beforeLoad: async () => {
    if (!canAccess('document')) {
      throw notFound();
    }
  },
  component: FundCreateComponent,
});

function FundCreateComponent() {
  const { loadHierarchy } = useHierarchyEndpoint();
  const navigate = useNavigate();
  const [toastCurrent] = useAtom<Toast | null>(toastAtom);

  const handleOnSubmitComplete = (status?: FundFormStatusEvt) => {
    loadHierarchy();
    navigate({ to: '/documents' });
    if (toastCurrent && status) {
      toastCurrent.show({
        severity: !status?.isError ? 'success' : 'error',
        summary: 'Form Submitted',
        detail: status?.message || 'Unknown status',
      });
    }
  };

  return (
    <div
      style={{
        height: '100vh',
        width: '100%',
      }}
    >
      <div className="h-4rem">
        <HeaderContainer>
          <Breadcrumb
            items={[
              { name: 'Funds', url: '/documents' },
              { name: 'Create Fund' },
            ]}
          />
          <PageTagline message="Create a Fund" />
        </HeaderContainer>
      </div>

      <div
        className="p-4"
        style={{
          height: 'calc(100% - 4rem)',
        }}
      >
        <div className="flex justify-between h-3rem"></div>
        <div
          style={{
            height: 'calc(100% - 3rem)',
          }}
        >
          <FundForm
            formMode="create"
            submitText="Create Fund"
            onSubmitComplete={handleOnSubmitComplete}
          />
        </div>
      </div>
    </div>
  );
}
